import React from 'react'
import Branch from '../components/details/branch'

function branch() {
  return (
    <Branch/>
  )
}

export default branch